import React, { useState } from 'react';
import Button from '../../common/Button';

// Converting warns, never blocks: a shop outside California may convert an
// estimate nobody formally approved.
//
// Converting saves and then converts — two requests. While they are in flight
// the button is disabled: a second click reached the convert route after the
// first had already made the document an invoice, and its 409 showed as an
// error toast on a conversion that had worked.
const ConvertToInvoiceButton = ({ authorizations, convertToInvoice }) => {
  const [confirming, setConfirming] = useState(false);
  const [converting, setConverting] = useState(false);

  const convert = async () => {
    if (converting) return;
    setConfirming(false);
    setConverting(true);
    try {
      await convertToInvoice();
    } finally {
      setConverting(false);
    }
  };

  if (converting) {
    return <Button variant="secondary" disabled>Converting…</Button>;
  }

  if (confirming) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-ink">No approval recorded — convert anyway?</span>
        <Button variant="secondary" size="sm" onClick={convert}>
          Convert anyway
        </Button>
        <Button variant="ghost" size="sm" onClick={() => setConfirming(false)}>Cancel</Button>
      </div>
    );
  }

  return (
    <Button
      variant="secondary"
      onClick={() => ((authorizations || []).length === 0 ? setConfirming(true) : convert())}
    >
      Convert to invoice
    </Button>
  );
};

export default ConvertToInvoiceButton;
